module.exports = __webpack_public_path__ + "img/logo@2x.e44ab45b.png";